// Port of api/fuel/app/classes/filter/package/games/game/prepare/plays.php
export default {
	run: function(local, global) {
		local.plays = { total: 0, duration: 0, last: 0, users: {}, user: { total: 0, duration: 0, first: 0, last: 0 } }
		var gamePlays = global.gamePlays[local.game_id]
		if (!gamePlays) return local
		var keys = Object.keys(gamePlays)
		for (var i = 0; i < keys.length; i++) {
			var p = gamePlays[keys[i]]
			local.plays.total += parseInt(p.total_plays || 0)
			local.plays.duration += parseInt(p.total_duration || 0)
			if (p.last_play > local.plays.last) local.plays.last = p.last_play
			local.plays.users[keys[i]] = parseInt(p.total_plays || 0)
		}
		if (global.userID && gamePlays[global.userID]) {
			var up = gamePlays[global.userID]
			local.plays.user = { total: parseInt(up.total_plays || 0), duration: parseInt(up.total_duration || 0), last: up.last_play || 0, first: up.first_play || 0 }
		}
		return local
	}
}
